export default __webpack_public_path__ + "static/media/5da439f5c495ed4dcb280f1a1b45615f.svg";